// ButtonPanelAdmin.js
import { CustomButton } from 'components/ui'
import LocalPoliceIcon from '@mui/icons-material/LocalPolice'
import { useNavigate, useLocation } from 'react-router-dom'

const ButtonPanelAdmin = () => {
  const navigate = useNavigate()
  const location = useLocation()
  
  // Estamos en admin o no?
  if (location.pathname === '/admin' || location.pathname.startsWith('/admin/'))  {
    return <LocalPoliceIcon />
  }

  return (
    <CustomButton
      type="green"
      className="btn-panel-admin"
      onClick={() => navigate('/admin')}
    >
      <LocalPoliceIcon />
      Panel de administración
    </CustomButton>
  )
}

export default ButtonPanelAdmin